export default {
  index: process.env.BASE_URL + '/api/modules/relay/index',
  myInfo: process.env.BASE_URL + '/api/modules/relay/myinfo',
  canPlayGame: process.env.BASE_URL + '/api/modules/relay/is_play',
  updateScore: process.env.BASE_URL + '/api/modules/relay/update_score',
  help: process.env.BASE_URL + '/api/modules/relay/help',
  signUp: process.env.BASE_URL + '/api/modules/relay/submit',
  rank: process.env.BASE_URL + '/api/modules/relay/rank',
  friends: process.env.BASE_URL + '/api/modules/relay/friend',
}